import moment from 'moment-timezone';

import {
  RENTAL_ITEMS_FORMS_NUMBERS,
  RENTAL_ITEMS_FORMS_ORDER
} from 'pages/create-rental-items/constants';

import { getAddOns } from 'utils/accommodations-and-activities/prepareAccommodationAndActivityData';

export const getPreparedDataToCreateRentalItems = (
  forms,
  pricesActiveSubTab,
  languages,
  isUpdate,
  deletedAddOns
) => {
  const languagesLength = languages.length;
  let secondLanguage = false;
  if (languagesLength > 1) secondLanguage = languages[languagesLength - 1];

  const generalForm = _getGeneralForm(forms);
  const descriptionForm = { ...forms['descriptionForm'].values };
  const addOnsForm = { ...forms['addOnsForm'].values };
  const rentedOutDatesForm ={...forms['rentedOutDatesForm'].values}; 

  let addOns = getAddOns(isUpdate, addOnsForm, secondLanguage);
  let rentedOutDates = _getRentedOutDates(rentedOutDatesForm.rentedOutList, isUpdate);
  const ownerIdObj = {
    businessOwnerId:
      forms.businessOwner.selectedBusinessOwner.ownerId ||
      forms.businessOwner.selectedBusinessOwner.id
  };
  const photoObj = forms['generalForm'].values.coverPhoto.file
    ? { photo: forms['generalForm'].values.coverPhoto.file }
    : {};
  delete generalForm.coverPhoto;

  const pricesFormName =
    RENTAL_ITEMS_FORMS_ORDER[RENTAL_ITEMS_FORMS_NUMBERS.pricesForm][
      pricesActiveSubTab
    ];

  const pricesForm = forms[pricesFormName]?.values || {};
  const prices = _getPrices(pricesForm);
  const hourlyPrices = _getPricesHourly(pricesForm.hourlyList);

  let deletedAddOnsObj = deletedAddOns.length
    ? {
        deletedAddOns: deletedAddOns
      }
    : {};

  return {
    ...photoObj,
    ...ownerIdObj,
    rentalItems: {
      ...generalForm,
      ..._getGeneralInfoSecondLanguage(forms, secondLanguage),
      ...descriptionForm,
      ..._getDescriptionInfoSecondLanguage(forms, secondLanguage),
      prices: prices,
      hourlyPrices : hourlyPrices,
      rentedOutDates : rentedOutDates,
      pricesType: pricesFormName,
    },
    addOns: addOns,
    ...deletedAddOnsObj
  };
};

const _getGeneralForm = forms => {
  const generalFormValues = { ...forms['generalForm'].values };
  const idObj = generalFormValues.id ? { id: generalFormValues.id } : {};

  return {
    ...idObj,
    title: generalFormValues.title,
    productCode: generalFormValues.productCode,
    availableUnits: parseInt(generalFormValues.availableUnits),
    status: parseInt (generalFormValues.status),
    itemsType: parseInt (generalFormValues.itemType),
    minDays:generalFormValues.minDays,
    maxDays:generalFormValues.maxDays
  };
};

const _getGeneralInfoSecondLanguage = (forms, secondLanguage) => {
  const countryCode = 'No';

  if (!secondLanguage)
    return {
      [`title${countryCode}`]: null
    };

  const generalFormSecondLanguage = {
    ...forms[`generalForm-${secondLanguage}`].values
  };

  return {
    [`title${countryCode}`]: generalFormSecondLanguage.title
  };
};

const _getDescriptionInfoSecondLanguage = (forms, secondLanguage) => {
  const countryCode = 'No';

  if (!secondLanguage) {
    return {
      [`description${countryCode}`]: null
    };
  }

  const generalFormSecondLanguage = {
    ...forms[`descriptionForm-${secondLanguage}`].values
  };
  const newSecondLanguageObject = {};

  Object.keys(generalFormSecondLanguage).map(
    field =>
      (newSecondLanguageObject[`${field}${countryCode}`] =
        generalFormSecondLanguage[field])
  );

  return newSecondLanguageObject;
};

const getPreparedPricesCurrency = item => {
  let prices = [];

  ['USD', 'EUR', 'NOK'].map(fieldName => {
    if (item[fieldName] && item[fieldName].length) {
      if (item[fieldName] === 'undefined') item[fieldName] = '0';
      prices.push({
        currency: fieldName,
        value: parseFloat(item[fieldName].split(',').join(''))
      });
    }
  });

  return prices;
};

const _getPricesPerDay = days => {
  const prices = [];

  days.forEach(day => {
    getPreparedPricesCurrency(day).forEach(price => {
      prices.push({
        ...price,
        day: day.day,
        type: 'day'
      });
    });
  });

  return prices;
};

const _getPricesWeek = weekList => {
  const prices = [];

  weekList.forEach(week => {
    getPreparedPricesCurrency(week).forEach(price => {
      prices.push({
        ...price,
      type: week.type,
      });
    });
  });

  return prices;
};
const _getPricesHourly = (hourlyList) => {

   if (!hourlyList || !Array.isArray(hourlyList)) {
    return []; 
  }
  
  const hourlyPrices = [];

  const masterEntry = hourlyList.find(item => item.isMaster === true);
  const hourlyEntries = hourlyList.filter(item => item.isMaster !== true && item.startTime);

  // Process master entry
  if (masterEntry) {
    ['USD', 'EUR', 'NOK'].forEach((currency) => {
      const value = parseFloat(masterEntry[currency]);
      if (!isNaN(value) && value >= 0) {
        hourlyPrices.push({
          currency,
          value,
          hour: -1, // Master price indicator
          minHours: parseInt(masterEntry.minHours) || 1,
          maxHours: parseInt(masterEntry.maxHours) || 24
        });
      }
    });
  }

  // Process hourly entries
  hourlyEntries.forEach((item) => {
    if (item.startTime) {
      let hour;
      
      // Handle both moment object and string formats
      if (moment.isMoment(item.startTime)) {
        hour = parseInt(item.startTime.format('H'));
      } else {
        // If it's a string or other format, try to parse it with moment
        const momentTime = moment(item.startTime);
        if (momentTime.isValid()) {
          hour = parseInt(momentTime.format('H'));
        } else {
          return; // Skip invalid dates
        }
      }

      ['USD', 'EUR', 'NOK'].forEach((currency) => {
        const value = parseFloat(item[currency]);
        if (!isNaN(value) && value >= 0) {
          hourlyPrices.push({
            currency,
            value,
            hour: hour,
            minHours: null,
            maxHours: null
          });
        }
      });
    }
  });

  return hourlyPrices;
};

const _getRentedOutDates = (rentedOutList) => {
  
  if (!rentedOutList || !Array.isArray(rentedOutList) || rentedOutList.length === 0) {
    return [];
  }

  return rentedOutList.map(item => {
    const { dateRange, numberOfUnits = 0 } = item;
    const { startDate, endDate } = dateRange || {};

    if (!startDate || !endDate) {
      throw new Error('Each date range must have start_date and end_date');
    }

    return {
      startDate,
      endDate,
      numberOfUnits
    };
  });
};
const _getPrices = pricesForm => {
  if (pricesForm.weekList) {
    return _getPricesWeek(pricesForm.weekList);
  } else if (pricesForm.days) {
    return _getPricesPerDay(pricesForm.days);
  } else {
    return getPreparedPricesCurrency(pricesForm);
  }
};